import { render, staticRenderFns } from "./PreviousInformation.component.vue?vue&type=template&id=65e7458e&scoped=true"
import script from "./PreviousInformation.component.vue?vue&type=script&lang=js"
export * from "./PreviousInformation.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7458e",
  null
  
)

export default component.exports